module.exports = __webpack_public_path__ + "img/russia.b36b3e38.png";